module.exports = __webpack_public_path__ + "static/media/arrowClose.cbd53f3f.svg";